import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-kpi-result-attachment-period-label',
    template: `
        @switch (periodType) {
            @case ('annual') {
                -
            }
            @case ('semi_annual') {
                {{ 'translate_half_year' | translate }} {{ period + 1 }}
            }
            @case ('quarter') {
                {{ 'translate_quarter' | translate }} {{ period + 1 }}
            }
            @case ('month') {
                {{ 'translate_month' | translate }} {{ period + 1 }}
            }
        }
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class KpiResultAttachmentPeriodLabelComponent {
    @Input() public period: number;
    @Input() public periodType: string;
}
